
const badge = {
  baseStyle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  
  sizes: {
    md: {
      p: '4px',
      h: '20px',
      minW: '20px',
      borderRadius: 'full',
      fontSize: '9.333px',
      fontWeight: 'medium',
      lineHeight: 'full',
      letterSpacing: '-0.056px'
    }
  },
  defaultProps: {
    colorScheme: 'red', 
    variant: 'solid',
    size: 'md'
  }
}

export default badge;
